import React from "react";
import styled from "styled-components";

import loaderImg from "../../media/CosmoRoundLogo.png";

const LoaderImg = styled.div`
	.animate {
		-webkit-animation: text-pop-up-top 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94) infinite alternate both;
		animation: text-pop-up-top 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94) infinite alternate both;
	}

	@-webkit-keyframes text-pop-up-top {
		0% {
			-webkit-transform: translateY(0);
			transform: translateY(0);
			-webkit-transform-origin: 50% 50%;
			transform-origin: 50% 50%;
			text-shadow: none;
		}
		100% {
			-webkit-transform: translateY(-50px);
			transform: translateY(-50px);
			-webkit-transform-origin: 50% 50%;
			transform-origin: 50% 50%;
			text-shadow: 0 1px 0 #cccccc, 0 2px 0 #cccccc, 0 3px 0 #cccccc, 0 4px 0 #cccccc, 0 5px 0 #cccccc, 0 6px 0 #cccccc, 0 7px 0 #cccccc,
				0 8px 0 #cccccc, 0 9px 0 #cccccc, 0 50px 30px rgba(0, 0, 0, 0.3);
		}
	}
	@keyframes text-pop-up-top {
		0% {
			-webkit-transform: translateY(0);
			transform: translateY(0);
			-webkit-transform-origin: 50% 50%;
			transform-origin: 50% 50%;
			text-shadow: none;
		}
		100% {
			-webkit-transform: translateY(-50px);
			transform: translateY(-50px);
			-webkit-transform-origin: 50% 50%;
			transform-origin: 50% 50%;
			text-shadow: 0 1px 0 #cccccc, 0 2px 0 #cccccc, 0 3px 0 #cccccc, 0 4px 0 #cccccc, 0 5px 0 #cccccc, 0 6px 0 #cccccc, 0 7px 0 #cccccc,
				0 8px 0 #cccccc, 0 9px 0 #cccccc, 0 50px 30px rgba(0, 0, 0, 0.3);
		}
	}
`;

const Loader = () => {
	return <LoaderImg>
		<img className="animate" src={loaderImg} width="200px" tip="Please wait while we are loading..." />
	</LoaderImg>;
};

export default Loader;
